import React, { useEffect, useState } from "react";
import AdminNavBar from "../AdminNavBar";
import NavLogo from "../NavLogo";
import { Row, Col,Button,Table, Spinner  } from "react-bootstrap";
import ReportNavbar from "./ReportNavbar";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import {CustomerFindAll, EmployeeFindAll, PaymentRecAdd} from "../../Admin/API/Api";
import axios from 'axios'
import { MDBDataTable } from 'mdbreact';
import { toast } from 'react-toastify';
import DailyStock from './../../Admin/AdminMaster/AdminOrderDS/DailyStock';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import html2pdf from "html2pdf.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ReportPaymentRec = () => {

  const userdata = JSON.parse(sessionStorage.getItem('userdata')) || {};
  let { branch_id: branchId, branch_name: Name, mrbranch_name: MarathiName } = userdata;
  const selectedLanguage = sessionStorage.getItem('selectedLanguage');
  const displayName = selectedLanguage === 'Marathi' ? MarathiName : Name;

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [selectedOption, setSelectedOption] = useState('');
    const [option, setOption] = useState('');
    const [data, setData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [loading, setLoading] = useState(false);
    const [employee_master, setEmployee_master] = useState([]);
    const [customer_master, setCustomer_master] = useState([]);
    const [employeeId, setEmployeeId] = useState('');
    const [customerId, setCustomerId] = useState('');

    const handleMonthChange = (event) => {
      setSelectedMonth(event.target.value);
    };

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const handleYearChange = (event) => {
      setSelectedYear(event.target.value);
    };

    const savedata = () => {
        setLoading(true);

        if (!selectedOption) {
            toast.error("Please select an option.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            return;
        }
    
        // Check if fromDate is empty when selectedOption is 2
        if (selectedOption === "2" && !fromDate) {
            toast.error("Please select a from date.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            return;
        }
    
        // Check if toDate is empty when selectedOption is 2
        if (selectedOption === "2" && !toDate) {
            toast.error("Please select a to date.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            return;
        }
    
        // Check if selectedMonth is empty when selectedOption is 1
        if (selectedOption === "1" && !selectedMonth) {
            toast.error("Please select a month.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            return;
        }

        if (selectedOption === "1" && !selectedYear) {
          toast.error("Please select a Year.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
          });
          setLoading(false);
          return;
      }
    
        // Check if option is empty
        if (!option) {
            toast.error("Please select an option.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            return;
        }
    
        // Check if employeeId is empty when option is 4
        if (option === "4" && !employeeId) {
            toast.error("Please select an employee.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            return;
        }
    
        // Check if customerId is empty when option is 5
        if (option === "5" && !customerId) {
            toast.error("Please select a customer.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            return;
        }
        setData([]);


        if (selectedOption === "1") {
            const Obj = {
                monthflag: parseInt(selectedOption),
                branch_id: branchId, 
                flag: parseInt(option),
                month: selectedMonth,
                year : selectedYear,
                employee_id : employeeId,
                customer_id : customerId,
            };
            console.log("obj console......", Obj);
        
            axios.post(PaymentRecAdd, Obj)
                .then(response => {
                    console.log("response.data", response);
                    if (response.data === "This Month not generate bill") {
                        toast.info("This Month not generate bill", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        setLoading(false);
                    } else {
                        console.log("response.data", response);
                        setData(response.data);
                        // setFromDate('');
                        // setToDate('');
                        // setSelectedMonth('');
                        // setOption('');
                        // setEmployeeId('');
                        // setCustomerId('');
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error("Error while fetching data from backend:", error);
                    setLoading(false);
                });
        }

                else if (selectedOption === "2") {

        const formattedDate = dayjs(fromDate).format('DD/MM/YYYY');
        const formattedDate1 = dayjs(toDate).format('DD/MM/YYYY');
        const data = {
            fromdate: formattedDate,
            monthflag: parseInt(selectedOption),
            todate: formattedDate1,
            branch_id: branchId, 
            year : selectedYear,
            flag: parseInt(option),
            employee_id : employeeId,
            customer_id : customerId,
        };
        console.log("obj console......", data);
    
        axios.post(PaymentRecAdd, data)
        .then(response => {
            console.log("response.data", response);
            if (response.data === "This Month not generate bill") {
                toast.info("This Month not generate bill", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setLoading(false);
            }else if(response.data === "This Month Not Receive payment"){
                toast.info("This Date Not Receive payment", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setLoading(false);
            } else {
                console.log("response.data", response);
                setData(response.data);
                // setFromDate('');
                // setToDate('');
                // setSelectedMonth('');
                // setOption('');
                // setEmployeeId('');
                // setCustomerId('');
                setLoading(false);
            }
        })
        .catch(error => {
            console.error("Error while fetching data from backend:", error);
            setLoading(false);
        });
}

    };

    useEffect(() => {
        setEmployeeId('');
        setCustomerId('');
    const fetchData = async () => {
        try {
          const [employeeRes, customerRes] = await Promise.all([
            axios.get(`${EmployeeFindAll}/${branchId}`),
            axios.get(`${CustomerFindAll}/${branchId}`),
          ]);
  
          if (employeeRes.data !== null) {
            setEmployee_master(employeeRes.data);
          }
  
          if (customerRes.data !== null) {
            setCustomer_master(customerRes.data);
          }
        } catch (error) {
          console.error('Failed to fetch initial data.', error);
        }
      };
  
      fetchData();
    }, []);

    const columns = [
        { label: (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'), field: 'srNo', sort: 'asc' },
        { label: selectedOption === "1" ? (selectedLanguage === 'Marathi' ? 'महिना' : 'Month') : (selectedLanguage === 'Marathi' ? 'या तारखेपासून' : 'From Date'), field: selectedOption === "1" ? 'monthName' : 'fromdate', sort: 'asc' },
        { label: selectedOption === "1" ? (selectedLanguage === 'Marathi' ? 'वर्ष' : 'Year') : (selectedLanguage === 'Marathi' ? 'आजपर्यंत' : 'To Date'), field: selectedOption === "1" ? 'selectedYear' : 'todate', sort: 'asc' },
        { label:  (selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'), field: 'employeeName', sort: 'asc' },
        { label: (selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name'), field: 'customer_name', sort: 'asc' },
        { label: (selectedLanguage === 'Marathi' ? 'रक्कम' : 'Amount'), field: 'amount', sort: 'asc' }
      ];
    
      const rows = data.map((item, index) => ({
        srNo: index + 1,
        selectedYear: item.year,
        monthName: item.monthName,
        fromdate: item.fromdate,
        todate: item.todate,
        employeeName: item.employeeName,
        customer_name: item.customer_name,
        amount: item.amount
      }));

    //   const generatePDF = () => {
    //     setLoading(true);
    //     if (rows.length === 0) {
    //         toast.error("No data available to generate PDF", {
    //             position: "top-right",
    //             autoClose: 3000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //         });
    //         setLoading(false);
    //         return;
    //     }
    
    //     const userdata = JSON.parse(sessionStorage.getItem('userdata'));
    //     const branchName = userdata.branch_name;
    
    //     let selectedText = '';
  
    //     if (option === '3') {
    //         selectedText = `All Payment Receive Bill ${selectedOption === '1' ? "(Month Wise)" : "(Date wise)"}`;
    //     } else if (option === '4') {
    //         selectedText = `Employee Payment Receive Bill ${selectedOption === '1' ? "(Month Wise)" : "(Date Wise)"}`;
    //     } else if (option === '5') {
    //         selectedText = `Customer Payment Receive Bill ${selectedOption === '1' ? "(Month Wise)" : "(Date Wise)"}`;
    //     }

    
    //     const documentDefinition = {
    //         content: [
    //             {
    //                 stack: [
    //                     { text: branchName, style: 'branchName' },
    //                     { text: `Report: ${selectedText}`, style: 'selectedOption' }, // Display selected option
    //                     { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 1 }] }, // Horizontal line
    //                     { text: ' ', margin: [0, 0, 0, 10] }, // Add space for separation
    //                 ]
    //             },
    //             {
    //                 table: {
    //                     headerRows: 1,
    //                     widths: ['auto', 'auto', 'auto', '*', '*', 'auto'], // Adjust widths as needed
    //                     body: [
    //                       [
    //                         { text: 'Sr. No', style: 'tableHeader' },
    //                         { text: selectedOption === '1' ? 'Month' : 'From Date', style: 'tableHeader' },
    //                         { text: selectedOption === '1' ? 'Year' : 'To Date', style: 'tableHeader'},
    //                         { text: 'Employee Name', style: 'tableHeader' },
    //                         { text: 'Customer Name', style: 'tableHeader' },
    //                         { text: 'Amount', style: 'tableHeader' }
    //                     ],
    //                         ...rows.map(row => [
    //                             row.srNo,
    //                             selectedOption === '1' ? row.monthName : row.fromdate,
    //                             selectedOption === '1' ? row.selectedYear : row.todate,
    //                             row.employeeName,
    //                             row.customer_name,
    //                             row.amount
    //                         ])
    //                     ],
    //                     style: 'tableStyle'
    //                 }
    //             }
    //         ],
    //         footer: function(currentPage, pageCount) {
    //             return {
    //                 text: 'Developed By : TechnoAarv Solution',
    //                 alignment: 'center',
    //                 fontFamily: 'Roboto',
    //                 fontSize: 8,
    //             };
    //         },
    //         styles: {
    //             branchName: { fontSize: 22, bold: true, alignment: "center", margin: [0, 5, 0, 30] },
    //             selectedOption: { fontSize: 14, bold: true, margin: [0, 0, 0, 5] },
    //             tableStyle: { margin: [0, 5, 0, 5] },
    //             tableHeader: { bold: true, fontSize: 12, color: 'black', fillColor: '#87b2b2' }
    //         }
    //     };
        

    //     pdfMake.createPdf(documentDefinition).open();
    //     setLoading(false);
    // };


    const generatePDF = async () => {
      setLoading(true);
      if (rows.length === 0) {
          toast.error("No data available to generate PDF", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
          });
          setLoading(false);
          return;
      }
      
      const element = document.getElementById("pdf-content");
    
      element.style.display = "block";
    
      await new Promise(resolve => setTimeout(resolve, 2000));
    
      const options = {
        margin: 10,
        filename: 'generated.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };
    
      html2pdf()
        .set(options)
        .from(element)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          const blobUrl = URL.createObjectURL(pdf.output("blob"));
          element.style.display = "none";
    
          window.open(blobUrl, "_blank");
    
          setLoading(false);
    
          toast.success("PDF generated successfully.");
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
          setLoading(false);
          toast.error("Error generating PDF");
        });
    };

    let selectedText = '';
  
    if (option === '3') {
      selectedText = `${selectedLanguage === 'Marathi' ? 'सर्व पेमेंट प्राप्त बिल' : 'All Payment Receive Bill'} ${selectedOption === '1' ? `(${selectedLanguage === 'Marathi' ? 'महिन्यानुसार' : 'Month Wise'})` : `(${selectedLanguage === 'Marathi' ? 'तारखेनुसार' : 'Date wise'})`}`;
  } if (option === '4') {
    selectedText = `${selectedLanguage === 'Marathi' ? 'कर्मचारी पेमेंट प्राप्त बिल' : 'Employee Payment Receive Bill'} ${selectedOption === '1' ? `(${selectedLanguage === 'Marathi' ? 'महिन्यानुसार' : 'Month Wise'})` : `(${selectedLanguage === 'Marathi' ? 'तारखेनुसार' : 'Date wise'})`}`;
} if (option === '5') {
  selectedText = `${selectedLanguage === 'Marathi' ? 'ग्राहक पेमेंट प्राप्त बिल' : 'Customer Payment Receive Bill'} ${selectedOption === '1' ? `(${selectedLanguage === 'Marathi' ? 'महिन्यानुसार' : 'Month Wise'})` : `(${selectedLanguage === 'Marathi' ? 'तारखेनुसार' : 'Date wise'})`}`;
}


    const renderInputBox = () => {
        switch (selectedOption) {
          case "1":
            return (<>
              <Col sm={12} md={2} className="mt-2">
                <TextField
                  id="month-input"
                  size="small"
                  label={selectedLanguage === 'Marathi' ? 'महिना निवडा' : 'Select Month'}
                  select
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  variant="outlined"
                  fullWidth
                  SelectProps={{
                    native: true,
                  }}
                >
                 <option value="" disabled></option>
                  <option value={1}>{selectedLanguage === 'Marathi' ? 'जानेवारी' : 'January'}</option>
                  <option value={2}>{selectedLanguage === 'Marathi' ? 'फेब्रुवारी' : 'February'}</option>
                  <option value={3}>{selectedLanguage === 'Marathi' ? 'मार्च' : 'March'}</option>
                  <option value={4}>{selectedLanguage === 'Marathi' ? 'एप्रिल' : 'April'}</option>
                  <option value={5}>{selectedLanguage === 'Marathi' ? 'मे' : 'May'}</option>
                  <option value={6}>{selectedLanguage === 'Marathi' ? 'जून' : 'June'}</option>
                  <option value={7}>{selectedLanguage === 'Marathi' ? 'जुलै' : 'July'}</option>
                  <option value={8}>{selectedLanguage === 'Marathi' ? 'ऑगस्ट' : 'August'}</option>
                  <option value={9}>{selectedLanguage === 'Marathi' ? 'सप्टेंबर' : 'September'}</option>
                 <option value={10}>{selectedLanguage === 'Marathi' ? 'ऑक्टोबर' : 'October'}</option>
                 <option value={11}>{selectedLanguage === 'Marathi' ? 'नोव्हेंबर' : 'November'}</option>
                 <option value={12}>{selectedLanguage === 'Marathi' ? 'डिसेंबर' : 'December'}</option>
                </TextField>
              </Col>
              <Col sm={12} md={2} className='mt-2' style={{ display: 'flex', flexDirection: 'column' }}>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="year-input-label">{selectedLanguage === 'Marathi' ? 'वर्ष निवडा' : 'Select Year'}</InputLabel>
          <Select
            labelId="year-input-label"
            id="year-input"
            size='small'
            value={selectedYear}
            onChange={handleYearChange}
            label={selectedLanguage === 'Marathi' ? 'वर्ष निवडा' : 'Select Year'}
          >
            {/* You can customize the range of years as needed */}
            {Array.from({ length: 10 }, (_, index) => {
              const year = new Date().getFullYear() - index;
              return <MenuItem key={year} value={year}>{year}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </Col>
      </> );
          case "2":
            return (<>
                <Col sm={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      label={selectedLanguage === 'Marathi' ? 'या तारखेपासून' : 'From Date'}
                      value={fromDate}
                      style={{ width: "100%" }}
                      onChange={(newDate) => {
                        setFromDate(newDate);
                      }}
                      slotProps={{ textField: { size: "small" } }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Col>
      
              <Col sm={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      label={selectedLanguage === 'Marathi' ? 'आजपर्यंत' : 'To Date'}
                      value={toDate}
                      style={{ width: "100%" }}
                      onChange={(newDate) => {
                        setToDate(newDate);
                      }}
                      slotProps={{ textField: { size: "small" } }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Col>
              </>
            );
          default:
            return null;
        }
      };
    

  return (
    <div>
            <AdminNavBar />
            <section className="home-section">
                <NavLogo />
                <ReportNavbar />

                <Row className="m-0 p-0 pt-4 px-md-4 px-2">
                    <Col
                        className=" rounded text-center pt-2"
                        style={{
                            display: "flex",
                            justifyContent: "start",
                            backgroundColor: "white",
                            border: "0px",
                            alignItems: "center",
                            alignContent: "center",
                            color: " rgb(47, 79, 79)",
                        }}
                    >
                        <h5>{selectedLanguage === 'Marathi' ? 'देयक प्राप्त अहवाल' : 'Payments Received Report'}</h5>
                    </Col>
                </Row>


                <Row className="m-0  py-3 px-2 mx-md-3 rounded">
                    <Col className="m-0 p-0 py-2  pb-3 rounded" style={{ background: "white" }}>
                    <Row className="m-0 p-0">
        <Col sm={12} md={2} className="mt-2">
          <TextField
            id="demo-simple-select"
            size="small"
            label={selectedLanguage === 'Marathi' ? 'पर्याय निवडा' : 'Select Option'}
            select
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            variant="outlined"
            fullWidth
            SelectProps={{
              native: true,
            }}
          >
            <option value="" disabled></option>
            <option value="1">{selectedLanguage === 'Marathi' ? 'महिना' : 'Month'}</option>
            <option value="2">{selectedLanguage === 'Marathi' ? 'तारीख' : 'Date'}</option>
          </TextField>
        </Col>
        {renderInputBox()}

        <Col sm={12} md={2} className="mt-2">
  <TextField
    id="demo-simple-select"
    size="small"
    label={selectedLanguage === 'Marathi' ? 'पर्याय निवडा' : 'Select Option'}
    select
    value={option}
    onChange={(e) => setOption(e.target.value)}
    variant="outlined"
    fullWidth
    SelectProps={{
      native: true,
    }}
  >
    <option value="" disabled></option>
    <option value="3">{selectedLanguage === 'Marathi' ? 'सर्व' : 'All'}</option>
    <option value="4">{selectedLanguage === 'Marathi' ? 'कर्मचारी' : 'Employee'}</option>
    <option value="5">{selectedLanguage === 'Marathi' ? 'ग्राहक' : 'Customer'}</option>
  </TextField>
</Col>

<Col sm={12} md={2} className="mt-2">
  {option && (
    <>
      {option === '4' && (
        <Autocomplete
          disablePortal
          id="employee-combo-box"
          size='small'
          style={{ width: '100%' }}
          options={employee_master}
          getOptionLabel={(option) => option.name}
          value={employee_master.find((item) => item.employee_id === employeeId) || null}
          onChange={(e, newValue) => setEmployeeId(newValue ? newValue.employee_id : '')}
          renderInput={(params) => <TextField {...params} size='small' label={selectedLanguage === 'Marathi' ? 'कर्मचारी निवडा' : 'Select Employee'} />}
        />
      )}
      {option === '5' && (
        <Autocomplete
          disablePortal
          id="customer-combo-box"
          size='small'
          style={{ width: '100%' }}
          options={customer_master}
          getOptionLabel={(option) => option.customer_name}
          value={customer_master.find((item) => item.customer_id === customerId) || null}
          onChange={(e, newValue) => setCustomerId(newValue ? newValue.customer_id : '')}
          renderInput={(params) => <TextField {...params} size='small' label={selectedLanguage === 'Marathi' ? 'ग्राहक निवडा' : 'Select Customer'}/>}
        />
      )}
    </>
  )}
</Col>
</Row>
               <Row >
                            <Col  className="mt-4" style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                                <Button
                                    style={{
                                        border: "0px",
                                        backgroundColor:
                                            "rgb(47, 79, 79)",
                                        fontSize: "17px",
                                        color: "white",
                                        borderRadius: "15px",
                                    }}
                                    className="buttonAll py-2 px-3 mx-2 shadow "
                                    type="submit"
                                    onClick={savedata}
                                    disabled={loading}
                    >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                      {selectedLanguage === 'Marathi' ? 'माहिती बघा' : 'Show Data'}</div>}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* Display table with fetched data */}
                <Row className="m-0 pt-1 px-2 mx-md-3 mb-3 rounded">
      <Col className="m-0 p-0 px-3 py-3 rounded" style={{ background: "white" }}>

      <Col style={{display:"flex",justifyContent:"end"}}>
                    <button
                                className=' button-30'
                                disabled={loading}
                                onClick={generatePDF}
                            >
                                {loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>{selectedLanguage === 'Marathi' ? 'पीडीएफ निर्यात करा' : 'Export Pdf'}</div>}
                                </button>
                    </Col>
        <MDBDataTable
          striped
          className='custom-datatable'
          bordered
          hover
          data={{ columns, rows }}
        />
      </Col>
    </Row>


 {/* ======================================pdf generate =============================== */}

 <div className="px-4" id="pdf-content"  style={{fontSize:"16px",fontFamily: "'Gotu', sans-serif",
fontFamily: "'Noto Sans Devanagari', sans-serif",display: "none"}}>

<div className="row">
  <div className="col-md-12">
        <div className="text-center fs-2 bold mb-3">{displayName}</div>
</div>
</div>

<div className="row">
  <div className="col-md-12">
        <div className="fs-5 bold pb-2" style={{borderBottom:"1px solid black"}}>{selectedLanguage === 'Marathi' ? 'अहवाल' : 'Report'}:  { selectedText}</div>
</div>
</div>
<Table striped bordered hover size="sm" className='rounded mb-3 mt-4' style={{textAlign:"center",border:"1px solid black"}}>
    <thead>
        <tr>
            {columns.map((column, index) => (
                <th key={index} style={{alignItems:"center", backgroundColor:"rgb(230, 237, 234)",border:"1px solid black",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-dark'>
                    {column.label}
                </th>
            ))}
        </tr>
    </thead>
    <tbody>
        {rows.map((row, index) => (
            <tr key={index} style={{fontSize:"14px"}}>
                {columns.map((column, columnIndex) => (
                    <td key={columnIndex} style={{ textAlign:"center",border:"1px solid black"}}>
                        {row[column.field]}
                    </td>
                ))}
            </tr>
        ))}
    </tbody>
</Table>


</div>

            </section>
        </div>
  );
};
export default ReportPaymentRec;

